export { default } from "./ScreenController";
